import { GRID_CHECKBOX_SELECTION_COL_DEF, GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AppContext } from '../../../app-context';
import IGridComponent from '../../../components/grid/i-grid.component';
import TitlePanel from '../../../components/title-panel/title-panel.component';
import { formatTo0Decimal, isEmpty, isEmptyArray, isNotEmpty } from '../../common/util.services';
import { getProcessingData } from '../order.services';
import { getMasterDataById } from '../../master-data/masterdata.services';
import './processing-data.component.scss';
import IDialogComponent from '../../../components/dialog/i-dialog.component';
import SpecsComponent from '../../master-data/specs/specs.component';
import ProcessingDataQuantity from './quantity.component';
import InputDataComponent from './input.component';
import {HelpOutline} from '@mui/icons-material';
import { Stack } from '@mui/system';
import dayjs from 'dayjs';
import { Button } from '@mui/material';
import ProductDetailComponent from '../../enquiry/enq-product/product-detail.component';
import { getEnquiryProduct } from '../../enquiry/enquiry.services';

const ProcessingData = () => {
  const appContext = useContext(AppContext);
  const navigate = useNavigate();
  const rows: GridRowsProp = [];
  const params = useParams();
  const orderId = params.orderId;
  const [orderCode, setOrderCode] = useState('NA')
  const [processingData, setProcessingData] = useState(rows);
  const [specsData, setSpecsData] = useState(null);
  const [openSpecs, setOpenSpecs] = useState(false);
  const [openQty, setOpenQty] = useState(false);
  const [openPrdDetail, setOpenPrdDetail] = useState(false);
  const [prdDetail, setPrdDetail] = useState(null);
  const [qtyData, setQtyData] = useState(null);
  const [openInput, setOpenInput] = useState(false);
  const [inputModel, setInputModel] = useState(null);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const columns: GridColDef[] = [
    { 
      field: 'code', headerName: 'Code', filterable: false, sortable: false, editable: false, width: 90,
      cellClassName: (params) => { return params.row.inputType },
      renderCell: (params) => { return <div className="cell-link" 
      onClick={() => { openSpecsPopup(params.row) }}>{params.row.code}</div> }
    },
    {...GRID_CHECKBOX_SELECTION_COL_DEF},
    { 
      field: 'product', headerName: 'Product', filterable: false, sortable: false, editable: false, width: 250,
      renderCell: (params) => (<Stack direction="row" alignItems="center" gap={1}>
                               <Button variant="contained" color='secondary'
                                onClick={() => openPrdDetailPage(params.row.productId)}
                                sx={{ width: 20, minWidth: 20, minHeight: 20, borderRadius: '50%',  
                                      padding: 0, fontSize: '0.65rem', lineHeight: 1, height: 20 }}>
                                {params.row.productSerial}</Button>{params.row.product + ' - ' + params.row.prdDesc}</Stack>)
    },
    { 
      field: 'inputSerial', headerName: 'Quantity - Input', filterable: false, sortable: false, editable: false, width: 200,
      renderCell: (params) => ('NA' !== params.row.inputSerial ?
      <Stack direction="row" alignItems="center" gap={1}>
        <HelpOutline fontSize='small' color="primary"/>
        {params.row.inputData.length > 1 ? 'Multiple Inputs' : 
                                           formatTo0Decimal(params.row.inputData[0].quantity) + ' ' + 
                                           params.row.inputData[0].uom + ' - ' + 
                                           params.row.inputData[0].inputCode}
      </Stack> : 'NA')
    },
    { 
      field: 'processLoss', headerName: 'PL', filterable: false, sortable: false, editable: false, width: 60,
      renderCell: (params: any) => isEmpty(params.row.processLoss) ? '' : 'NA' === params.row.inputSerial ? 'NA' : params.row.processLoss + '%'
    },
    { field: 'outputDesc', headerName: 'Output', filterable: false, sortable: false, editable: false, width: 275 },
    { 
      field: 'outputQty', headerName: 'O/P Qty', filterable: false, sortable: false, editable: false, width: 105,
      renderCell: (params: any) => isEmpty(params.row.outputQty) ? '' : formatTo0Decimal(params.row.outputQty) + ' ' + params.row.uom
    },
    { 
      field: 'pojoCode', headerName: 'PO/JS', filterable: false, sortable: false, editable: false, width: 110,
      renderCell: (params) => { return <div className={'NA' !== params.row.pojo ? "cell-link" : '' }
      onClick={() => { openPOJOPage(params.row) }}> {params.row.pojo}</div> }
    },
    { field: 'masterPojo', headerName: 'Master PO/JS', filterable: false, sortable: false, editable: false, width: 110,
      renderCell: (params) => { return <div className={isEmpty(params.row.masterPojo) ? '' : 'cell-link'}
      onClick={() => { openMergePojoPage(params.row) }}> {isEmpty(params.row.masterPojo) ? 'NA' : params.row.masterPojo}</div> }
    },
    { 
      field: 'challanCode', headerName: 'Challan', filterable: false, sortable: false, editable: false, width: 115,
      renderCell: (params) => { return <div className={'NA' !== params.row.challan ? "cell-link" : '' }
      onClick={() => { openPOJOPage(params.row) }}> {params.row.challan}</div> }
    }
  ];
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isEmptyArray(rows)) {
      getProcessingData(orderId, '', appContext,
        (response: any) => {
          setProcessingData(response.data);
          setOrderCode(isEmpty(response.data[0]) ? 'NA' : response.data[0].orderCode);
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  }, []);

  const handleCellClick = (value: any) => {
    const field = value.field;
    if('inputSerial' === field && 'NA' !== value.row.inputSerial) {
      setInputModel(value.row.inputModel);
      setQtyData(value.row.inputData);
      setOpenQty(true);
    } else if('inputQty' === field) {
      setQtyData(value.row.inputData);
    } else if('outputQty' === field && isNotEmpty(value.row.outputQty)) {
      setQtyData(value.row.outputData);
    }
  };

  const openSpecsPopup = (row: any) => {
    if(isNotEmpty(row.code)) {
      getMasterDataById(row.inputId, appContext,
        (response: any) => {
          appContext.setShowLoader(false);
          setLoading(false);
          setSpecsData(response.data);
          setOpenSpecs(true);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  };

  const openPOJOPage = (row: any) => {
    if('NA' !== row.pojo) {
      navigate('/order/pojo/list/' + row.linkId);
    }
  }

  const openMergePojoPage = (row: any) => {
    if(isNotEmpty(row.masterPojo)) {
      navigate('/pojo/merge/' + row.orderId);
    }
  }

  const onRowSelectionModelChange = (ids: any) => {
    const selectedIds = new Set(ids);
    const selectedRowData = processingData.filter((row) =>
      selectedIds.has(row.id)
    );
    setSelectedRows(selectedRowData);
  }

  function createPojoDetail(rows: any) {
    let pojoDetail: any = [];

    let id = 0;
    for(let i = 0; i < rows.length; ++i) {
      let row = rows[i];
      for(let j = 0; j < row.inputData.length; ++j) {
        if('NA' === row.inputData[j].inputCode) {
          continue;
        }
        ++id;
        let inputData = row.inputData[j];
        let pojoModel = {serial: id, inputCode: inputData.inputCode, inputUom: 'NA' === inputData.inputCode ? 'NA' : inputData.uom,
                         inputId: inputData.inputId, inputDesc: inputData.description, inputQuantity: inputData.quantity };
        pojoDetail.push(pojoModel);
      }
    }
    
    return pojoDetail;
  }

  const createSaleChallan = () => {
    navigate('/order/challan/sale/' + orderId);
  }

  const mergePOJO = () => {
    let pojo = false;
    processingData.forEach(element => {
      if('NA' !== element.pojo) {
        pojo = true;
      }
    });

    if(pojo) {
      navigate('/pojo/merge/' + orderId);
    } else {
      appContext.setDialogMessage('There is no PO/JS created.');
    }
  }

  const createPOJO = () => {
    let labor = 0, process = 0, material = 0;
    for(let i = 0; i < selectedRows.length; ++i) {
      let inputType = selectedRows[i].inputType;
      if('Labor' === inputType) {
        ++labor;
      } else if('Process' === inputType) {
        ++process;
      } else if('Material' === inputType) {
        ++material;
      }
    }

    if(isEmptyArray(selectedRows)) {
      appContext.setDialogMessage('Select a row.');
      return;
    }

    if((labor > 0 && (process > 0 || material > 0)) || 
       (process > 0 && (labor > 0 || material > 0)) || 
       (material > 0 && (process > 0 || labor > 0))) {
      appContext.setDialogMessage('Select similar input type.');
      return;
    }

    if(labor > 1 || process > 1) {
      appContext.setDialogMessage('Select one labor or process at a time.');
      return;
    }

    let row = selectedRows[0];
    let orderDate = dayjs(selectedRows[0].orderDate).format('YYYY-MM-DD');
    navigate('/order/pojo/new', {state: {inputs: createPojoDetail(selectedRows), productId: row.productId, outputUom: row.uom, 
                                         costingId: row.costingId, orderId: orderId, supplier: row.supplier, inputType: row.inputType, 
                                         inputName: row.input2, product: row.product, inputCode: row.code, inputId: row.inputId, 
                                         unitCost: row.unitCost, processLoss: row.processLoss, outputDesc: row.outputDesc, 
                                         outputQty: row.outputQty, pack: row.pack, completedQty: row.completedQty, output: row.output, 
                                         linkId: row.linkId, orderCode: row.orderCode, consumption: row.consumption, orderDate: orderDate,
                                         type: labor > 0 || process > 0 ? 'Job Sheet' : 'Purchase Order'}});
  }

  const closeSpecs = () => {
    setOpenSpecs(false);
  }

  const closeQty = () => {
    setOpenQty(false);
  }

  const closeInputPopup = () => {
    setOpenInput(false);
  }

  const closePrdDetail = () => {
    setOpenPrdDetail(false);
  }

  const openPrdDetailPage = (prdId: string) => {
    getEnquiryProduct(prdId, appContext,
      (response: any) => {
        appContext.setShowLoader(false);
        setLoading(false);
        setPrdDetail(response.data);
        setOpenPrdDetail(true);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
  }

  const getMainPanel = () => {
    return <>
      <IGridComponent title={''} rows={processingData} columns={columns} loading={loading} maxHeight={550} hideFooterPagination={true}
        showAddBtn={false} showApproveAction={false} showDeleteAction={false} showUpAction={false} showDownAction={false}
        getRowId={(row: any) => row.id} hideFooter={false} cellClick={handleCellClick} checkboxSelection={true}
        showExtBtn={true} extBtnText={'Create PO/JS'} extBtnAction={createPOJO} disableMultipleRowSelection={true}
        showExtBtn2={true} extBtn2Text={'Master PO/JS'} extBtn2Action={mergePOJO}
        showExtBtn3={true} extBtn3Text={'Sale Challan'} extBtn3Action={createSaleChallan}
        extraText={'Order Code: ' + orderCode} showExtraText={true} extraTextColor='blue'
        disableRowSelectionOnClick={true} rowSelectionModelChange={onRowSelectionModelChange}/>
      <IDialogComponent onClose={closeSpecs} open={openSpecs} title='Specifications' dialogClass={'spec-panel'} 
        dialogBody={<SpecsComponent data={specsData} />} />
      <IDialogComponent onClose={closeQty} open={openQty} title='Input Details & Quantity' 
        dialogBody={<ProcessingDataQuantity data={qtyData} />} />
      <IDialogComponent onClose={closeInputPopup} open={openInput} title='Input Data' 
        dialogBody={<InputDataComponent data={inputModel} />} />
      <IDialogComponent onClose={closePrdDetail} open={openPrdDetail} title={'Product Details'}
        dialogBody={<ProductDetailComponent readOnly={true} data={prdDetail} close={closePrdDetail}/>} />
    </>
  }

  return <TitlePanel title='Bill of Material' panelBody={getMainPanel()} />
}

export default ProcessingData;